<template>
  <div id="plant">
    <div class="back">
      <img
        src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560966708985.png"
        alt=""
        @click="$router.back()"
      />
    </div>

    <div class="rule-mine">
      <div class="pinpai">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608356202969991.png"
          alt=""
        />
      </div>
      <div class="rule">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560963410193.png"
          alt=""
          @click="doShowRule"
        />
      </div>
      <div class="mine">
        <router-link to="/creative/tmnc/mine">
          <img
            src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560959252364.png"
            alt=""
          />
        </router-link>
      </div>
    </div>

    <!-- 葡萄架 -->
    <div class="cc">
      <div class="puj">
        <img
          :src="ptjUrl"
          alt=""
        />
        <div class="js" :class="{ 'an-l-to-r': jiaoshui }">
          <img
            src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560964284274.png"
            alt=""
          />
        </div>

        <div class="sf" :class="{ 'an-r-to-updown': shifei }">
          <img
            src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560959808415.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="btns">
      <div class="btn">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560963097030.png"
          alt=""
          @click="doJiaoshui"
        />
      </div>
      <div class="btn">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560965891599.png"
          alt=""
          @click="doChucao"
        />
      </div>
      <div class="btn">
        <img
          src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560961092429.png"
          alt=""
          @click="doShifei"
        />
      </div>
    </div>
    <div class="gcj" :class="{ 'an-r-to-l': chucao }">
      <img
        src="https://i.tmuyun.com/webpic/W0202206/W020220607/W020220607560964535633.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { oneUserScore, addScore, countZhongzhi, oneLingqu } from "@/api/tmnc";
import { Dialog, Toast } from "vant";
export default {
  name: "TmncPlant",
  data() {
    return {
      chucao: false,
      jiaoshui: false,
      shifei: false,
      isAdd: false,
      doing: false,
      count: 0,
      ptjUrl: "",
      putao: {},
    };
  },
  mounted() {
    oneLingqu()
      .then((res) => {
        if (res.code == 1) {
          this.putao = res.data.putao;

          // 获取种植次数
          countZhongzhi()
            .then((re) => {
              if (re.code == 1) {
                this.count = re.data;
                this.choosePtj(this.putao.color, this.count);
              }
            })
            .catch((er) => {
              console.log(er);
            });
        }
      })
      .catch((err) => {
        this.$router.replace("creative/tmnc");
        console.log(err);
      });

    // 判断今天是否获得过积分
    oneUserScore()
      .then((res) => {
        if (res.code == 1) {
          this.isAdd = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    choosePtj(color, count) {
      if (color == 1) {
        // 青色
        if (count < 10) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380457544381.png";
        } else if (count >= 10 && count < 20) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380456103412.png";
        } else if (count >= 20) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380456868465.png";
        }
      } else if (color == 2) {
        // 紫色
        if (count < 10) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380457202259.png";
        } else if (count >= 10 && count < 20) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380456445258.png";
        } else if (count >= 20) {
          this.ptjUrl =
            "https://i.tmuyun.com/webpic/W0202206/W020220608/W020220608380455719425.png";
        }
      }
    },
    doAddScore() {
      if (this.isAdd || this.doing) return false;

      this.doing = true;

      addScore()
        .then((res) => {
          if (res.code == 1) {
            this.isAdd = true;
            Toast.success("+5积分");
          }
          this.doing = false;
        })
        .catch((err) => {
          this.doing = false;
          console.log(err);
        });
    },
    doShowRule() {
      Dialog.alert({
        title: "规则",
        message:
          "选择成为某农场（农庄）合伙人后选择要种植的葡萄，每人每天完成浇水或施肥或除草，可获得5积分。",
      });
    },
    doChucao() {
      if (this.chucao) return false;

      this.chucao = true;

      setTimeout(() => {
        this.chucao = false;
        this.doAddScore();
      }, 4000);
    },
    doJiaoshui() {
      if (this.jiaoshui) return false;

      this.jiaoshui = true;

      setTimeout(() => {
        this.doAddScore();
        this.jiaoshui = false;
      }, 4000);
    },
    doShifei() {
      if (this.shifei) return false;

      this.shifei = true;

      setTimeout(() => {
        this.doAddScore();
        this.shifei = false;
      }, 4000);
    },
  },
};
</script>

<style lang="less" scoped>
/* 从右往左的动画 */
@keyframes rtol {
  0% {
    right: 1%;
  }

  10% {
    right: 10%;
  }
  20% {
    right: 20%;
  }
  30% {
    right: 30%;
  }
  40% {
    right: 40%;
  }
  50% {
    right: 50%;
  }
  60% {
    right: 60%;
  }
  70% {
    right: 70%;
  }
  80% {
    right: 80%;
  }
  90% {
    right: 90%;
  }
  100% {
    right: 100%;
  }
}

@keyframes jiaoshui {
  0% {
    left: -10%;
  }

  10% {
    left: -5%;
  }

  20% {
    left: 0%;
  }
  30% {
    top: 58%;
    left: 5%;
  }

  40% {
    top: 53%;
    left: 10%;
  }

  50% {
    top: 48%;
    left: 15%;
  }

  60% {
    top: 53%;
    left: 15%;
  }
  70% {
    top: 58%;
    left: 15%;
  }
  80% {
    top: 63%;
    left: 15%;
  }
  90% {
    top: 58%;
    left: 10%;
  }
  100% {
    top: 53%;
    left: 5%;
  }
}

@keyframes shifei {
  0% {
    right: -10%;
  }

  10% {
    right: -5%;
  }

  20% {
    right: 0%;
  }
  30% {
    top: 58%;
    right: 5%;
  }

  40% {
    top: 53%;
    right: 10%;
  }

  50% {
    top: 48%;
    right: 15%;
  }

  60% {
    top: 53%;
    right: 15%;
  }
  70% {
    top: 58%;
    right: 15%;
  }
  80% {
    top: 63%;
    right: 15%;
  }
  90% {
    top: 58%;
    right: 10%;
  }
  100% {
    top: 53%;
    right: 5%;
  }
}

#plant {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(https://i.tmuyun.com/webpic/W0202205/W020220530/W020220530566869774115.jpg);
  background-size: 100% 100%;
  background-color: #a17651;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  img {
    width: 100%;
  }
  .back {
    position: absolute;
    top: 1.5%;
    left: 3%;
    width: 30px;
  }
  .rule-mine {
    z-index: 3;
    position: absolute;
    top: 1.5%;
    right: 3%;
    width: 28%;
    text-align: right;
    .rule {
      margin-top: 10px;
    }
    .rule,
    .mine {
      img {
        text-align: right;
        width: 65%;
      }
    }
  }

  .cc {
    width: 90vw;
    position: absolute;
    left: 0;
    top: 6%;
    .puj {
      position: relative;
      .js {
        position: absolute;
        width: 35vw;
        left: -40%;
        top: 58%;
      }
      .sf {
        position: absolute;
        width: 26vw;
        right: -40%;
        top: 58%;
      }
    }
  }
  .btns {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 90vw;
    left: 50%;
    top: 65%;
    margin-left: -45vw;
    .btn {
      flex: 0 0 28%;
    }
  }

  .gcj {
    // display: none;
    width: 40vw;
    position: absolute;
    bottom: 0.5%;
    right: -50%;
  }

  .an-r-to-l {
    animation: rtol 4s linear;
  }

  .an-l-to-r {
    animation: jiaoshui 4s linear;
  }

  .an-r-to-updown {
    animation: shifei 4s linear;
  }
}
</style>